var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mheader",class:{'dark':_vm.themeName=='dark'}},[_vm._t("default"),_c('div',{staticClass:"rightcss"},[_c('router-link',{attrs:{"to":"/search"}},[_c('i',{staticClass:"iconfont icon-sousuo"})])],1)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }